"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoneyObject = void 0;
const infrastructure_1 = require("../../infrastructure");
class MoneyObject extends infrastructure_1.ValueObjectBase {
    constructor(data) {
        super();
        this.initialize(data);
    }
    toPlain() {
        return { ...this };
    }
}
exports.MoneyObject = MoneyObject;
//# sourceMappingURL=Money.js.map